import { render, staticRenderFns } from "./EditorPopUp.vue?vue&type=template&id=4fd6daab&"
import script from "./EditorPopUp.vue?vue&type=script&lang=js&"
export * from "./EditorPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports